(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/containers/background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/containers/background.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const bgPositions = {
  high: {
    percent: 15,
    max: 300
  },
  medium: {
    percent: 40,
    max: 500
  },
  low: {
    percent: 50,
    max: 700
  }
};
const getBackgroundStyle = function () {
  var _bgPositions$imagePos, _bgPositions$imagePos2;
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'high' : _ref$imagePosition,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return _objectSpread({
    backgroundColor: '#ffed00',
    backgroundImage: "url(\"".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/triss-horizon.png\")"),
    backgroundPosition: "center clamp(100px, ".concat((_bgPositions$imagePos = bgPositions[imagePosition]) === null || _bgPositions$imagePos === void 0 ? void 0 : _bgPositions$imagePos.percent, "%, ").concat((_bgPositions$imagePos2 = bgPositions[imagePosition]) === null || _bgPositions$imagePos2 === void 0 ? void 0 : _bgPositions$imagePos2.max, "px)"),
    backgroundRepeat: 'repeat-x',
    minHeight: '100%',
    width: '100%'
  }, style);
};
const Background = _ref2 => {
  let children = _ref2.children,
    imagePosition = _ref2.imagePosition,
    style = _ref2.style;
  return React.createElement("div", {
    className: "triss-next-lobby js-triss-background",
    style: getBackgroundStyle({
      imagePosition,
      style
    })
  }, children);
};
setGlobal('svs.tickets.next.containers.Background', Background);

 })(window);